// extracted by mini-css-extract-plugin
export default {"tutorial":"style_tutorial__61wla"};